import { SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const createSqlTemplateValidationSchema = Yup.object().shape({
  name: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  sqlStatement: Yup.string().required(SystemMessage.INPUT_REQUIRED),
});
